<template>
  <div class="settings-wrap">
    <router-view> </router-view>
  </div>
</template>
